import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from '@app/authentication/authentication.service';
import { OrganizationService } from '@shared/http/organizations.service';
import { UserService } from '@shared/http/users.service';
import { Organization } from '@shared/models/Organization';
import { User } from '@shared/models/User';
import { StorageService } from '@shared/services/storage.service';
import { switchMap, finalize } from 'rxjs/operators';
import { throwError } from 'rxjs'

@Component({
  selector: 'app-external-accouting-confirmation',
  templateUrl: './external-accouting-confirmation.component.html',
  styleUrls: ['./external-accouting-confirmation.component.scss']
})
export class ExternalAccoutingConfirmationComponent implements OnInit {

  public currentUser = User.fromLocalStorage();
  public isConfirming = false;

  constructor(
    public dialogRef: MatDialogRef<ExternalAccoutingConfirmationComponent>,
    private organizations: OrganizationService,
    private users: UserService,
    private storage: StorageService
  ) { }

  ngOnInit(): void {
  }

  public goToOttimizza() {
    if (this.isConfirming) {
      return;
    }
    this.isConfirming = true;
    let organization: Organization;

    this.organizations.getOttimizza()
    .pipe(
      switchMap(response => {
        organization = response.record;
        return organization?.id ?
          this.users.patch(this.currentUser.id, { organization }) :
          throwError(null);
      }),
      finalize(() => this.isConfirming = false)
    ).subscribe(async () => {
      const user = User.fromLocalStorage();
      user.organization = organization;
      await this.storage.store(AuthenticationService.STORAGE_KEY_USERINFO, JSON.stringify(user));
      window.location.reload();
    })
  }

}
